/* eslint-disable prefer-destructuring */
import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../theme/toyotaTheme";
import * as Button from "../../components/Button";
import * as CashPrice from "../price/CashPrice";
import * as MonthlyPrice from "../price/MonthlyPrice";

export const BasketList = styled.div<SpaceProps>`
    width: 100%;
    text-align: start;
    ${space};
`;

export const BasketListItem = styled.div`
    display: flex;
    ${({ theme: localTheme }) =>
        localTheme.isRTL &&
        css`
            flex-direction: row-reverse;
        `};
    justify-content: space-between;
    gap: ${theme.space[1]}px;

    @supports not (gap: ${theme.space[1]}px) {
        & > div:not(:nth-last-child(1)) {
            margin-right: ${theme.space[1]}px;
        }
    }
    padding-top: ${theme.space[1]}px;
    padding-bottom: ${theme.space[1]}px;
    border-bottom: 1px solid ${theme.colors.grey2};
    &:last-child {
        border-bottom: 0;
    }

    html[dir="rtl"] & {
        @supports not (gap: ${theme.space[1]}px) {
            & > div:not(:nth-last-child(1)) {
                margin-left: ${theme.space[1]}px;
                margin-right: 0;
            }
        }
    }
`;

export const ListItemLabel = styled.div`
    display: flex;
    text-align: start;
`;

export const ActionWrapper = styled.div`
    display: flex;
    align-self: flex-start;
    line-height: 0.8;
    ${Button.Link} {
        height: 20px;
        line-height: 1;

        /* Make icon size smaller and fix vertical alignment*/
        .icon {
            position: relative;
            top: -2px;
            &::before {
                font-size: 1rem !important;
            }
        }
    }
`;

export type BasketListItemValueProps = {
    hasPrice?: boolean;
    hasRemoveButton?: boolean;
};

export const ListItemValue = styled.div<BasketListItemValueProps>`
    display: flex;
    position: relative;
    flex: 1;
    align-items: center;
    align-self: flex-start;
    justify-content: flex-end;
    ${({ theme: localTheme }) =>
        localTheme.isRTL &&
        css`
            flex-direction: row-reverse;
        `};
    text-align: end;
    white-space: nowrap;

    ${CashPrice.Text},
    ${MonthlyPrice.Text} {
        margin-top: 0;
        font-family: ${theme.fonts.regular};
        font-size: 1.3rem;
        line-height: 2rem;
        text-transform: none;
    }

    ${Button.Link} {
        font-family: ${theme.fonts.regular};
    }

    div {
        font-size: 1.3rem;
        color: ${theme.colors.primaryBlack};
    }
`;

export const PriceFallback = styled.div`
    font-size: 1.3rem;
    color: ${theme.colors.grey7};
`;
